import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import loadable from "@loadable/component";
import pMinDelay from "p-min-delay";
import { useDispatch, useSelector } from 'react-redux';




import Marquee from "react-fast-marquee";
import Graph1 from '../Graph/graph1';
import ChartPie from '../Chart/PieChart';
import { getAdminDashboardApi } from '../../service/api/user/getAdminDashboard';
import { Spinner } from 'react-bootstrap';







const tableData = [
    { number: 'Hllo  ', title: '1.48586 ', time: '5m', status: 'Confirmed', statusColor: 'label-success' },
    { number: '65432187', title: '2.12389 ', time: '4m', status: 'Unconfirmed', statusColor: 'label-warning' },
    { number: '78954123', title: '3.65412 ', time: '6m', status: 'Canceled', statusColor: 'label-danger' },
    { number: '55542545', title: '1.48586 ', time: '5m', status: 'Confirmed', statusColor: 'label-success' },
    { number: '65432187', title: '2.12389 ', time: '4m', status: 'Unconfirmed', statusColor: 'label-warning' },

];

const Dashboard1 = () => {
    const { permissionArr } = useSelector((state) => state.user);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const permissionArray = permissionArr[0] || [];

    const [dashboardObj, setDashboardObj] = useState({})

    const [responceMsg, setResponceMsg] = useState("");
    const [toasterType, setToasterType] = useState();
    const [handleToaster, setHandleToaster] = useState(false);

    const [totalPayable, setTotalPayable] = useState("")
    const [totalPayout, setTotalPayout] = useState("")

    const [totalinvoiceOverdue, setTotalInvoiceOverdue] = useState("")

    const [totalPendingForApproval, setTotalPendingForApproval] = useState("")
    const [categories, setCategories] = useState([])
    const [months, setMonths] = useState([])

    const amounts = [];


    const widgetChart = [
        {
            id: 1, price: '65,123', bgcolor: 'linear-gradient(142.98deg, rgb(255, 116, 1) 1.99%, rgb(255, 168, 0) 99.97%)', nameVal: "Customer", link: "/addInvoice", show: true, icon: "receipt_long"
        },
        {
            id: 2, price: '75,542', bgcolor: 'rgba(23, 90, 169)', nameVal: "Pro's"
            , link: "/invoiceList", show: true, icon: "task"
        },

        { id: 3, price: '40,742', bgcolor: 'rgb(101 168 247)', nameVal: "Active", link: "/", show: true, icon: "bolt" },
    ];

    const widgetChartTop = [
        {
            id: 1, price: totalPayout, bgcolor: '#F2994A', nameVal: "Total Professional", link: "", show: true, icon: "school"
        },
        { id: 2, price: totalPendingForApproval, bgcolor: '#F2994A', nameVal: "Total  customer", link: "", show: true, icon: "pending_actions" }
        ,
        { id: 3, price: totalPayable, bgcolor: '#F2994A', nameVal: "Total Companies", link: "/", show: true, icon: "person" },

    ];
    const tickerSlider = [
        { price: 'Teacher meeting at 12:30 ', title: '1.48586 ' },
        { price: 'School meeting' },
        { price: 'Function discussion' },
        { price: 'Lab Discussion' },
        { price: 'IT security' },
        { price: 'Driver enquiry' },
        { price: 'Admission schedule' },

    ];
    const today = new Date(); // Get today's date as a Date object

    const options = { year: 'numeric', month: 'short', day: 'numeric' };
    const formattedDate = today.toLocaleDateString('en-US', options);



    const getAdminDashboardFn = () => {

        let details = new FormData();

        dispatch(getAdminDashboardApi(details, (res) => {
            // console.log(res.data)
            setResponceMsg(res.data.message);
            setToasterType("success");
            setHandleToaster(true);

            setDashboardObj(res.data)

            setTimeout(() => {
                setHandleToaster(false);
            }, 11000);
        }, (err) => {

            setResponceMsg(err.data.message);
            setToasterType("error");
            setHandleToaster(true);

            setTimeout(() => {
                setHandleToaster(false);
            }, 11000);
        }))
    }

    useEffect(() => {
        getAdminDashboardFn();
    }, [])

    const quickLinks = [
        { id: 1, nameVal: "Users", link: "/admin", icon: "person", iconClass: 'bi bi-people-fill' },
        { id: 2, nameVal: "Transactions", link: "/admin/transactions", icon: "receipt_long", iconClass: 'bi bi-list-columns-reverse' },
        { id: 3, nameVal: "Services", link: "/admin/services", icon: "task", iconClass: 'bi bi-journal-check' },
        // { id: 4, nameVal: "Feedbacks", link: "/admin/feedbackList", icon: "bolt", iconClass: 'bi bi-lightning-charge-fill' },
    ];


    return (
        <>
            <div className="row px-2 mt-4 ">
                <div className="col-xl-12">

                    {dashboardObj?.roles?.length > 0 &&
                        <div className="row mb-3" style={{}}>
                            {dashboardObj?.roles?.map((item, ind) => (
                                <div className="col-xl-3 col-lg-6 col-12 col-sm-12 pe-lg-2" key={ind}>
                                    <div className={`card  `} style={{ borderRadius: '0px', border: '1px solid lightgray', flexDirection: 'row', minHeight: '80px' }}>
                                        <div className='d-flex justify-content-center align-items-center ' style={{ padding: '12px', position: 'relative', bottom: '22px', width: '56px', background: '#F2994A', left: '6px', borderRadius: '10px', maxHeight: '50px' }}>
                                            <span className="material-icons" style={{ color: 'white' }}>
                                                {/* {`business`} */}
                                                {`person`}
                                            </span>
                                        </div>

                                        <div className="card-header border-0 pb-0 d-flex justify-content-start" style={{ paddingLeft: '0px', paddingRight: '0px' }} >
                                            <div className="chart-num-days d-flex align-items-center" style={{ gap: "15px", marginBottom: '12px' }} >
                                                <span className="font-w600 fs-5">
                                                    {`${item?.role_display_name_chr} : `}
                                                </span>

                                                <span className=" text-black font-w600 fs-5">
                                                    {`${item?.role_user_count}`}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}

                            {permissionArray?.includes("VIEW REGISTERED COMPANIES LIST") && <div className="col-xl-3 col-lg-6 col-12 col-sm-12 pe-lg-2">
                                <div className={`card  `} style={{ borderRadius: '0px', border: '1px solid lightgray', flexDirection: 'row', minHeight: '80px' }}>
                                    <div className='d-flex justify-content-center align-items-center ' style={{ padding: '12px', position: 'relative', bottom: '22px', width: '56px', background: '#F2994A', left: '6px', borderRadius: '10px', maxHeight: '50px' }}>
                                        <span className="material-icons" style={{ color: 'white' }}>
                                            {`business`}
                                        </span>
                                    </div>

                                    <div className="card-header border-0 pb-0 d-flex justify-content-start" style={{ paddingLeft: '0px', paddingRight: '0px' }} >
                                        <div className="chart-num-days d-flex align-items-center" style={{ gap: "15px", marginBottom: '12px' }} >
                                            <span className="font-w600 fs-5">
                                                {`Companies : `}
                                            </span>

                                            <span className=" text-black font-w600 fs-5">
                                                {`${dashboardObj?.company_count ? dashboardObj?.company_count : 0}`}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>}

                        </div>
                    }


                    <div className='row mb-3 px-2 border rounded-3'>
                        <div className='col-12 font-w500 fs-4 my-2 text-black'>
                            <span>{`Category wise Pros`}</span>
                        </div>

                        {dashboardObj?.category_wise_pro?.length > 0 ? <>
                            {dashboardObj?.category_wise_pro?.map((item, ind) => (
                                <div className="col-xl-3 col-lg-6 col-12 col-sm-12 pe-lg-2" key={ind}>
                                    <div className={`bg-light mb-2 p-2 d-flex align-items-center`} style={{ borderRadius: '0px', border: '1px solid lightgray', flexDirection: 'row', minHeight: '80px' }}>
                                        <div className='d-flex align-items-center w-100'>
                                            <div className='d-flex align-items-center justify-content-center' style={{ width: '70px' }}>
                                                <span className='position-relative'>
                                                    <i className='fa fa-user' style={{ fontSize: '30px' }}></i>
                                                    {item?.category_wise_online_pro_count > 0 && <Spinner variant="success" size="sm" animation="grow" style={{ position: 'absolute', top: '21px', right: '-6px' }} />}
                                                </span>
                                            </div>
                                            <div className='d-flex flex-column w-100'>
                                                <div className='mb-2'>
                                                    <span className="font-w600 fs-5 text-black">{`${item?.category_display_name_chr == "Home Check-Up" ? "Home Inspector" : item?.category_display_name_chr}`}</span>
                                                </div>

                                                <div className='row'>
                                                    <div className='col-6  d-flex '>
                                                        <span className="font-w600 fs-5">{`Total : `}</span>
                                                        <span className="font-w600 fs-5 text-black ms-2">{` ${item?.category_wise_pro_count}`}</span>
                                                    </div>
                                                    <div className='col-6  d-flex  '>
                                                        <span className="font-w600 fs-5">{`Live : `}</span>
                                                        <span className="font-w600 fs-5 text-black ms-2">{` ${item?.category_wise_online_pro_count}`}</span>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </> :
                            <>
                                <span>{`No data found`}</span>
                            </>
                        }
                    </div>

                    <div className="col-xxl-12 ">
                        {/* <div className="overflow-hidden bg-transparent dz-crypto-scroll shadow-none">
                        <div className="js-conveyor-example">
                             <ul className="crypto-list" id="crypto-webticker">
                                <Marquee
                                    speed = {80}
                                    loop = {0}
                                    pauseOnHover = {true}
                                    // pauseOnClick={true}
                                    // play={false}
                                 
                                >
                                    {tickerSlider.map((item, index)=>(
                                       
                                        <div className="card overflow-hidden " key={index}>
                                            <div className="card-body d-flex align-items-center">
                                                <div className="me-4">
                                                    <p className="mb-2 fs-13">Announcement</p>
                                                    <h4 className="heading mb-0">{item.price}</h4>
                                                </div>
                                             
                                            </div>
                                        </div>                                        
                                    ))}
                                </Marquee>                               
                            </ul>
                        </div>
                    </div> */}
                    </div>
                </div>

                <div className='row d-flex justify-content-between'>

                    <div className="col-xl-6 pe-xl-2" style={{ zom: '0.9' }}>
                        <div className="card" style={{ borderRadius: '4px', border: '1px solid lightgray', background: 'white !important' }}>
                            <div className="card-header">
                                <h4 className="heading mb-0" >Pro's Data</h4>
                            </div>
                            <div className="card-body " >
                                <div className='row' style={{ display: 'flex' }}>
                                    <ChartPie dashboardObj={dashboardObj} />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-xl-6 ps-xl-2" style={{ zom: '0.9' }}>
                        <div className="card" style={{ borderRadius: '4px', border: '1px solid lightgray', background: 'white !important' }}>
                            <div className="card-header">
                                <h4 className="heading mb-0" >Quick Links</h4>
                            </div>
                            <div className="card-body pt-0" >
                                {/* <div className='row'>
                                    {quickLinks.map((item, ind) => (
                                        <div className='col-3 d-flex flex-column align-items-center m-2 cursor-pointer overlay-action-btn py-3' onClick={() => { navigate(item.link) }} style={{ padding: '6px', borderRadius: '12px', background: '#d3d3d380', color: 'rgba(23, 90, 169, 0.78)' }}>
                                            <span className="material-icons">
                                                {item.icon}
                                            </span>
                                            <span className='text-center' > {item.nameVal}</span>
                                        </div>
                                    ))}
                                </div> */}

                                <div className='row'>
                                    <div className='d-flex flex-wrap'>
                                        {quickLinks.map((item, ind) => (
                                            <>
                                                <div
                                                    className='shadow-sm d-flex rounded-2 flex-column align-items-center justify-content-center m-2 cursor-pointer overlay-action-btn'
                                                    style={{ background: '#d3d3d380', color: 'rgba(23, 90, 169, 0.78)', height: '100px', minWidth: '100px' }}
                                                    onClick={() => { navigate(item.link) }}
                                                >
                                                    <span style={{ fontSize: '25px' }}>
                                                        <i className={`${item.iconClass}`}></i>
                                                    </span>
                                                    <span className='text-center font-w600'>{`${item.nameVal}`}</span>
                                                </div>
                                            </>
                                        ))}

                                    </div>
                                </div>

                                {permissionArray.includes("VIEW REGISTERED COMPANIES LIST") &&
                                    <>
                                        <hr />

                                        <div className='row'>
                                            <span className=''>{`Chilll analytics`}</span>
                                        </div>

                                        <div className='row'>
                                            <div className='d-flex flex-wrap'>
                                                <div>
                                                    <a
                                                        // href='https://analytics.google.com/analytics/web/?authuser=0&hl=en#/p306035865/reports/dashboard?r=firebase-overview'
                                                        href='https://analytics.google.com/analytics/web/?authuser=0&hl=en#/p469091659/reports/intelligenthome?params=_u..nav%3Dmaui'
                                                        target="_blank"
                                                        rel="noreferrer"
                                                    >
                                                        <div
                                                            className='shadow-sm d-flex rounded-2 flex-column align-items-center justify-content-center m-2 cursor-pointer overlay-action-btn'
                                                            style={{ background: '#d3d3d380', color: 'rgba(23, 90, 169, 0.78)', height: '100px', minWidth: '100px' }}
                                                        >
                                                            <span style={{ fontSize: '25px' }}>
                                                                <i className={`bi bi-bar-chart`}></i>
                                                            </span>
                                                            <span className='text-center font-w600'>{`Google`}</span>
                                                            <span className='text-center font-w600'>{`analytics`}</span>
                                                        </div>
                                                    </a>
                                                </div>

                                                <div>
                                                    <a
                                                        href='https://play.google.com/console/u/0/developers/8611406231785313390/app-list?pli=1'
                                                        target="_blank"
                                                        rel="noreferrer"
                                                    >
                                                        <div
                                                            className='shadow-sm d-flex rounded-2 flex-column align-items-center justify-content-center m-2 cursor-pointer overlay-action-btn'
                                                            style={{ background: '#d3d3d380', color: 'rgba(23, 90, 169, 0.78)', height: '100px', minWidth: '100px' }}
                                                        >
                                                            <span style={{ fontSize: '25px' }}>
                                                                <i className={`bi bi-android2`}></i>
                                                            </span>
                                                            <span className='text-center font-w600'>{`Andriod`}</span>
                                                            <span className='text-center font-w600'>{`downloads`}</span>
                                                        </div>
                                                    </a>
                                                </div>

                                                <div>
                                                    <a
                                                        href='https://appstoreconnect.apple.com/analytics/apps/d30'
                                                        target="_blank"
                                                        rel="noreferrer"
                                                    >
                                                        <div
                                                            className='shadow-sm d-flex rounded-2 flex-column align-items-center justify-content-center m-2 cursor-pointer overlay-action-btn'
                                                            style={{ background: '#d3d3d380', color: 'rgba(23, 90, 169, 0.78)', height: '100px', minWidth: '100px' }}
                                                        >
                                                            <span style={{ fontSize: '25px' }}>
                                                                <i className={`bi bi-apple`}></i>
                                                            </span>
                                                            <span className='text-center font-w600'>{`iOS`}</span>
                                                            <span className='text-center font-w600'>{`downloads`}</span>
                                                        </div>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                }

                            </div>
                        </div>
                    </div>
                </div>

                {/* <div className='row d-flex justify-content-between'>
                    <div className="col-xl-8 " style={{ paddingRight: '10px' }}>
                        <div className="row">
                            <div className="col-xl-12">
                                <div className="card" style={{ borderRadius: '4px', border: '1px solid lightgray', background: 'white ' }}>
                                    <div className="card-header">
                                        <div className="d-flex align-items-center">
                                            <i className="fa fa-person scale-2 text-warning"></i>
                                            <h4 className="heading ms-3 mb-0" >Live Pro Details</h4>
                                        </div>
                                        <div className="d-flex align-items-center">
                                            <h4 className="heading ms-3 mb-0" >{formattedDate}</h4>
                                        </div>
                                    </div>
                                    <div className="card-body pt-2">

                                        <Graph1 category={categories} month={months} amount={amounts} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-xl-4" style={{ zom: '0.9' }}>
                        <div className="card" style={{ borderRadius: '4px', border: '1px solid lightgray', background: 'white !important' }}>
                            <div className="card-header">
                                <h4 className="heading mb-0" >Pro's Data</h4>
                            </div>
                            <div className="card-body " >
                                <div className='row' style={{ display: 'flex' }}>
                                    <ChartPie />






                                </div>




                            </div>
                        </div>
                    </div>
                </div> */}

                {/* <div className='row d-flex justify-content-between'>
                    <div className="col-xl-4" style={{ zom: '0.9' }}>
                        <div className="card" style={{ borderRadius: '4px', border: '1px solid lightgray', background: 'white !important' }}>
                            <div className="card-header">
                                <h4 className="heading mb-0" >Quick Links</h4>
                            </div>
                            <div className="card-body pt-0" >
                                <div className='row' style={{ display: 'flex' }}>
                                    {widgetChart.map((item, ind) => (
                                        item.show && <div className='col-3 d-flex flex-column align-items-center m-2 ' onClick={() => { navigate(item.link) }} style={{ cursor: "pointer", gap: '10px', padding: '6px', borderRadius: '12px', background: '#d3d3d380', color: 'rgba(23, 90, 169, 0.78)' }}>
                                            <span className="material-icons">
                                                {item.icon}
                                            </span>
                                            <span style={{ textAlign: 'center' }}> {item.nameVal}</span>
                                        </div>
                                    ))}






                                </div>




                            </div>
                        </div>
                    </div>
                    <div className="col-xl-8 " style={{ paddingLeft: '10px' }}>
                        <div className="row">
                            <div className="col-xl-12">
                                <div className="card" style={{ borderRadius: '4px', border: '1px solid lightgray', background: 'white ' }}>
                                    <div className="card-header">
                                        <div className="d-flex align-items-center">
                                            <i className="fa fa-person scale-2 text-warning"></i>
                                            <h4 className="heading ms-3 mb-0" >Live Pro Details</h4>
                                        </div>
                                    </div>
                                    <div className="card-body pt-2">

                                        <Graph1 category={categories} month={months} amount={amounts} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> */}

            </div>
        </>
    )
}
export default Dashboard1;